"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormatter = void 0;
const FALLBACK_STRING = "-";
/** Non-breaking space */
const NBSP = "\xa0";
const CREDITS_CURRENCY = "CREDITS";
const creditsLabelTranslations = {
    en: "credits",
};
const creditsLabel = (language = "en") => {
    if (creditsLabelTranslations[language] != null) {
        return creditsLabelTranslations[language];
    }
    // handle falling back to a more general language code
    const parts = language.split("-");
    while (parts.length > 1) {
        parts.pop();
        const lang = parts.join("-");
        if (creditsLabelTranslations[lang] != null) {
            return creditsLabelTranslations[lang];
        }
    }
    return creditsLabelTranslations.en;
};
const currencyFormatter = () => (value, language, options) => {
    if (typeof value !== "number" || Number.isNaN(value)) {
        return FALLBACK_STRING;
    }
    const intl = new Intl.NumberFormat(language, {
        style: "currency",
        currencyDisplay: "narrowSymbol",
        // If the user sets the currency to `CREDITS`, arbitrarily fall back to
        // `USD`. This shouldn't affect the output in most circumstances due to our
        // `currencyDisplay` setting.
        currency: options.currency === CREDITS_CURRENCY ? "USD" : options.currency,
    });
    if (options.currency !== CREDITS_CURRENCY) {
        return intl.format(value);
    }
    // For credits, use the normal localised currency formatting, but strip the
    // currency symbol and any adjacent whitespace, and append the `creditsLabel`.
    const valueStr = intl
        .formatToParts(value)
        .filter((part) => part.type !== "currency")
        .map((part) => part.value)
        .join("")
        .trim();
    return `${valueStr}${NBSP}${creditsLabel(language)}`;
};
exports.currencyFormatter = currencyFormatter;
//# sourceMappingURL=data:application/json;base64,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